import { render, staticRenderFns } from "./CartSummary.vue?vue&type=template&id=3cab2cd9&scoped=true&"
import script from "./CartSummary.vue?vue&type=script&lang=js&"
export * from "./CartSummary.vue?vue&type=script&lang=js&"
import style0 from "./CartSummary.vue?vue&type=style&index=0&id=3cab2cd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cab2cd9",
  null
  
)

export default component.exports